import type { BasketItem } from '../../../types/payment-link';
import type { BasketTotals } from '../types';

const round = (value: number): number => Math.round(value * 100) / 100;

export const calculateBasketTotals = (items: BasketItem[]): BasketTotals => {
  return items.reduce(
    (acc, item, index) => {
      const unitPrice = parseFloat(item.unitPrice.value);
      const quantity = item.quantity;
      const vatRate = parseFloat(item.vatRate || '0') / 100;

      const itemTotalExclVat = round(unitPrice * quantity);
      const itemVat = round(itemTotalExclVat * vatRate);
      const itemTotalInclVat = round(itemTotalExclVat + itemVat);

      return {
        totalExcludingVat: round(acc.totalExcludingVat + itemTotalExclVat),
        totalVat: round(acc.totalVat + itemVat),
        totalIncludingVat: round(acc.totalIncludingVat + itemTotalInclVat),
        itemTotals: {
          ...acc.itemTotals,
          [index]: itemTotalExclVat,
        },
      };
    },
    {
      totalExcludingVat: 0,
      totalVat: 0,
      totalIncludingVat: 0,
      itemTotals: {},
    }
  );
};
